import { useTrackEvent } from '@/App/Blotter/useTrackEvent.ts';
import { useAlgoTileId, useValidateAlgo } from '@/App/tiles/orders/AlgoOrders/AlgoContext.tsx';
import { OrderRow } from '@/App/tiles/orders/components/OrderRow.tsx';
import { OmsFieldErrorWrapper } from '@/components/ui/OmsFieldErrorWrapper.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectAlgoErrors, selectAlgoRandomize } from '@/store/orders/algoOrders/selectors.ts';

export const AlgoRandomize = () => {
  const tileId = useAlgoTileId();
  const track = useTrackEvent();

  const value = useAppSelector((state) => selectAlgoRandomize(state, tileId));
  const errors = useAppSelector((state) => selectAlgoErrors(state, tileId));

  const validateAlgo = useValidateAlgo();

  const handleRandomizeChange = (newValue: boolean) => {
    track('Order action', 'Randomize changed');
    validateAlgo({
      randomize: newValue,
    });
  };

  const randomizeError = errors?.randomize;

  return (
    <OrderRow labelId="order.fields.randomize">
      <OmsFieldErrorWrapper errors={randomizeError}>
        <div className="form-check form-check-sm">
          <input
            id="randomize"
            className="form-check-input me-8px"
            type="checkbox"
            checked={value}
            onChange={(e) => handleRandomizeChange(e.target.checked)}
            data-e2e={'randomize-checkbox'}
          />
        </div>
      </OmsFieldErrorWrapper>
    </OrderRow>
  );
};
